import React from "react";
import PillarTableHeaderCell from "shared/components/pillar-table/header/PillarTableHeaderCell";
import { filterPillarTableDataColumns } from "shared/components/pillar-table/nested/pillarTableNestedTableHelpers";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { type PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";

const PillarTableHeader = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>() => {
  const context = usePillarTableContext<
    RowGeneric,
    ExtraPropsGeneric,
    InlineEditFormGeneric
  >();
  // Nested tables sit in the same children list as the columns but never get a
  // heading. They are dropped before indexing so that a header cell's index
  // matches the body cell's index, which is what `columnRefs` and
  // `fixedColumnWidths` are keyed on.
  const columns = filterPillarTableDataColumns(context.columns || []);
  //TODO:  The custom report column logic should live in the the usePillarTableColumnsValues instead of here
  //TODO:  Add functionality for `.doNotDisplay` similar to `.doNotExport` - GS 2025-10-07
  // https://github.com/Parthenon-Management/PillarMS/pull/1876/files#r2412296853

  const hasInlineDeleteButton = Boolean(context.handleInlineDelete);
  const hasInlineEditButton = Boolean(context.handleInlineEdit);

  return (
    <thead
      className="pillartable-table-header whitespace-nowrap"
      data-testid={
        context?.testidTable ? `${context?.testidTable}-table-head` : undefined
      }
    >
      <tr
        className={
          context.isDynamicHeight ? "pillartable-table-header-sticky" : ""
        }
      >
        {columns?.map((column, index) => (
          <PillarTableHeaderCell
            key={`pillar-table-header-${index}`}
            column={column}
            index={index}
          />
        ))}
        {hasInlineEditButton && (
          <th className="pillartable-table-header-cell-general" />
        )}
        {hasInlineDeleteButton && (
          <th className="pillartable-table-header-cell-general" />
        )}
      </tr>
    </thead>
  );
};

export default PillarTableHeader;
